import React from 'react';
import { connect } from 'react-redux';
import List from '@material-ui/core/List';
import Drawer from '@material-ui/core/Drawer';
import Leads from './Leads';
import Users from './Users';
import Files from './Files';
import Notes from './Notes';
import Reports from './Reports';
import ListItem from './ListItem';
import LeadsStatuses from './LeadsStatuses';
import '../../styles/Dock.scss';

const Dock = (props) => {
    // noinspection JSUnresolvedVariable
    return (
        <Drawer className="dock" variant="permanent">
            <div/>
            <List>
                <ListItem title="Профиль" to="/profile/"/>
                {(props.user.is_superuser)
                    ? <LeadsStatuses/>
                    : null
                }
                <Reports/>
                <Leads/>
                {(!props.user.affiliate)
                    ? <>
                        <ListItem title="Офферы" to="/offers/"/>
                        <Users/>
                        <Files/>
                        <Notes/>
                        <ListItem title="Журнал" to="/journal/"/>
                        <ListItem title="Настройки" to="/settings/"/>
                    </>
                    : null
                }
            </List>
        </Drawer>
    );
};

export default connect(
    (state) => ({
        user: state.auth.user,
    }),
    null,
)(Dock);

